import { useMsal } from '@azure/msal-react'
import { Box, Flex, HStack, Image, Spacer, Stack, Text } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { AiFillPrinter } from 'react-icons/ai'
import { typeStore } from '../Utils/Helpers'
import { SingleTicketNumber } from '../Utils/ApiCalls'

export default function PrintPickUpGroup({ SingleData, onClick, mainData }) {


    console.log("singlee data", SingleData)
    console.log("main data", mainData)


    const [Data, setData] = useState([])
    const { instance } = useMsal();
    const currentAccount = instance.getActiveAccount();
    console.log("currentAcc", currentAccount);


    const [Hide, setHide] = useState(false);

    const printNow = () => {
        setHide(true)

        setTimeout(() => {
            window.print()

        }, 1000);
        setTimeout(() => {
            setHide(false)


        }, 2000);
    }

    const FetchSingle = async ()=>{
        try{
         
            let result = await SingleTicketNumber(SingleData.ticket)

            console.log("FetchSingle", result)
            if(result.status === true){

                setData(result.queryresult.allrequest)
            }

        }catch(e){

            console.log(e)
        }
    }

    useEffect(() => {

        FetchSingle()

    }, []);
    return (
        <Box mx={"6%"} py="32px">

            <HStack>
                <Image src='/logo.jpg' width={"10%"} />
                <Spacer />
                {
                    !Hide && (

                        <Text cursor={"pointer"} fontSize={"20px"} fontWeight="500" onClick={onClick}>{"<"} Back </Text>
                    )
                }
            </HStack>
            <Text mt="10px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Ims Print Out</Text>

            <HStack>
                <Stack spacing={"10px"}>
                    <HStack>
                        <Text fontSize={"18px"} fontWeight="600">Ticket No: </Text>
                        <Text fontSize={"18px"} fontWeight="500">{SingleData.ticket} </Text>
                    </HStack>
                    <HStack>
                        <Text fontSize={"18px"} fontWeight="600">Print Date: </Text>
                        <Text fontSize={"18px"} fontWeight="500">{moment(Date.now()).format("DD/MM/YYYY")} </Text>
                    </HStack>
                    <HStack>
                        <Text fontSize={"18px"} fontWeight="600">Time Stamp: </Text>
                        <Text fontSize={"18px"} fontWeight="500">{moment(SingleData.requestdate).format("DD/MM/YYYY")} </Text>
                    </HStack>
                </Stack>
                <Spacer />
                {
                    !Hide && (

                        <HStack fontSize={"20px"} cursor="pointer" onClick={printNow}>
                            <Box><AiFillPrinter /></Box>
                            <Text color="#fff" bgColor="navy" fontSize={"14"} px="8px" py="3px" rounded="8px">Print</Text>
                        </HStack>
                    )
                }
            </HStack>
            <Text mt="5px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Receiver's Details</Text>

            <Stack spacing={"10px"} mx="20%" borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Name: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData.staffname} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">StaffNo: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData.staffid} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Office: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData.department} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Receiving Dept.: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData.department} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Zone: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData.zone||""} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600"> Location: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData.location||""} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">District: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData.district||""} </Text>
                </HStack>
                <HStack>
                    <Text fontSize={"18px"} fontWeight="600">Feeder: </Text>
                    <Spacer />
                    <Text fontSize={"18px"} fontWeight="500">{SingleData.feeder||""} </Text>
                </HStack>
            </Stack>

            <Text mt="5px" fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Product Details</Text>
            <Stack spacing={"10px"} mx="6%" borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">

                <HStack fontWeight={"700"}>
                    <Text w="20%" fontSize={"18px"} >Product name</Text>
                    <Spacer />
                    <Text w="20%" fontSize={"18px"} >Code</Text>
                    <Spacer />
                    <Text w="20%" fontSize={"18px"} >Qty Requested</Text>
                    <Spacer />
                    <Text w="20%" fontSize={"18px"} >Qty Approved</Text>
                    <Spacer />
                    <Text w="20%" fontSize={"18px"} >Status</Text>
                    <Spacer />
                    <Text w="20%" fontSize={"18px"} >Store</Text>
                    <Spacer />
                    <Text w="20%" fontSize={"18px"} >Created Date</Text>
                </HStack>
                {
                    Data && (
                        Data?.map((item, i) => (
                            <HStack>
                                <Text w="20%" fontSize={"15px"} fontWeight="400">{item.productname} </Text>
                                <Spacer />
                                <Text w="20%" fontSize={"15px"} fontWeight="400">{item.productshelf} </Text>
                                <Spacer />
                                <Text w="20%" fontSize={"15px"} fontWeight="400">{item.qtycontrol} </Text>
                                <Spacer />
                                <Text w="20%" fontSize={"15px"} fontWeight="400">{item.qtyrequested} </Text>
                                <Spacer />

                                <Text w="20%" fontSize={"15px"} fontWeight="400">{item.status == "Awaiting Confirmation"?"Awaiting Pickup":item.status} </Text>

                                <Spacer />
                                <Text w="20%" fontSize={"15px"} fontWeight="400">{typeStore(item.productkey.store)} </Text>
                                <Spacer />
                                <Text w="20%" fontSize={"15px"} fontWeight="400">{moment(item.createdAt).format('DD/MM/YYYY, h:mm:ss a')} </Text>
                            </HStack>
                        ))
                    )
                }

                
            </Stack>

            <Flex flexWrap={"wrap"} justifyContent="space-between" mt="10">
                <Box w={["100%", "45%"]}>
                    <Text fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Issued by</Text>
                    <Stack spacing={"10px"} mx="5%" borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Name of Store Personnel: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{currentAccount.name} </Text>
                        </HStack>
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Staff email: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{currentAccount.username} </Text>
                        </HStack>
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Signature: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">..................... </Text>
                        </HStack>

                    </Stack>
                </Box>
                <Box w={["100%", "45%"]}>
                    <Text fontSize={"18px"} textTransform="uppercase" fontWeight="600" textAlign={"center"}>Picked by</Text>
                    <Stack spacing={"10px"} mx="5%" borderColor={"gray.gray400"} borderWidth="1px" mt="10px" p="10px">
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Name of Staff: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{SingleData.staffname} </Text>
                        </HStack>
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Staff Id: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">{SingleData.staffid} </Text>
                        </HStack>
                        <HStack>
                            <Text fontSize={"18px"} fontWeight="600">Signature: </Text>
                            <Spacer />
                            <Text fontSize={"18px"} fontWeight="500">..................... </Text>
                        </HStack>

                    </Stack>
                </Box>

            </Flex>


        </Box>
    )
}
